var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktokFooter = function SvgTiktokFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    strokeOpacity: 0.2,
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.909 11.218A3.85 3.85 0 0 1 19.16 8H16.4l-.004 11.061a2.32 2.32 0 0 1-2.316 2.233 2.321 2.321 0 0 1-2.32-2.32c0-1.28 1.04-2.32 2.32-2.32.239 0 .468.04.685.107v-2.818a5 5 0 0 0-.685-.05A5.086 5.086 0 0 0 9 18.974c0 1.72.859 3.24 2.169 4.16a5.05 5.05 0 0 0 2.911.921 5.086 5.086 0 0 0 5.08-5.08v-5.609A6.57 6.57 0 0 0 23 14.6v-2.76c-.77 0-1.489-.23-2.091-.622"
  })));
};
export default SvgTiktokFooter;